<script>
  import { getHeaders } from "../headers.svelte";

  let uploadedBytes = 0
  let uploadedBytesAllFiles = 0
  let totalByteSizeToUpload = 1;
  let tries = 0;
  let errorMessage = ""

  $: uploadCompletion = (uploadedBytesAllFiles + uploadedBytes) / totalByteSizeToUpload * 100;

  export let multiple, accept, uploadEndpoint, uploadParam, allFiles;

  function dragEnter(evt) {
    document.querySelector("#drop-container").classList.add("border-secondary")
    // prevent browser from opening file in new tab (default behaviour)
    evt.preventDefault();
  };

  function onDroppedFile(evt) {
    document.querySelector("#drop-container").classList.remove("border-secondary")
    document.querySelector("form input[type=file]").files = evt.dataTransfer.files;
    refreshFileList();
    evt.preventDefault();
  }

  function refreshFileList() {
    const newlyAddedFiles = Array.from(document.querySelector("form input[type=file]").files)
    totalByteSizeToUpload = newlyAddedFiles.reduce((sum, file) => sum + file.size, 0)
    uploadImages(newlyAddedFiles)
  }

  function uploadImage(file, filesToUpload) {
    if(!file) {
      uploadedBytesAllFiles = 0
      uploadedBytes = 0
      return
    }

    const formData = new FormData();

    formData.append(uploadParam, file, file.name);

    let headers = getHeaders()

    var request = new XMLHttpRequest();

    request.open('POST', uploadEndpoint)

    request.setRequestHeader("X-CSRF-Token", headers.get("X-CSRF-Token"));
    request.responseType = 'json';

    request.upload.addEventListener('progress', function(e) {
      uploadedBytes = e.loaded
    });

    request.addEventListener("load", function() {
      if(request.status == 200) {
        allFiles = allFiles.concat(
          request.response["medias"].map((media) => { return { id: media.data.attributes.id, url: media.data.attributes.url }})
        )

        uploadedBytesAllFiles += uploadedBytes
        uploadedBytes = 0
        tries = 0

        uploadImage(filesToUpload.pop(), filesToUpload)
        errorMessage = ""
      }
      else if(request.status == 402 || request.status == 422) {
        errorMessage = request.response["message"]
        uploadedBytes = 0
        tries = 0
        uploadImage(filesToUpload.pop(), filesToUpload)
      }
      else {
        if(tries < 3) {
          uploadImage(file, filesToUpload)
        }
        else {
          errorMessage = "Une erreur s'est produite, veuillez réessayer ou contacter support@toploc.com"
          uploadImage(filesToUpload.pop(), filesToUpload)
        }
      }

    });

    tries += 1
    request.send(formData);
  }

  function uploadImages(filesToUpload){
    errorMessage = ""
    uploadImage(filesToUpload.pop(), filesToUpload)
  }

</script>

<label
  on:dragover|preventDefault={dragEnter}
  on:dragenter|preventDefault={dragEnter}
  on:drop|preventDefault={onDroppedFile}
  for="input-file-drop" id="drop-container" class="flex flex-col items-center justify-center p-6 text-center text-gray-600 border border-dashed rounded cursor-pointer border-3">

  <slot name="header">
    <p class="font-semibold">
      Faites glisser vos photos ou cliquez pour les choisir directement depuis vos fichiers.
    </p>
    </slot>
  <p class="mt-2 text-xs explainer">Les images au format .jpeg, .jpg ou .png sont acceptées.</p>

  <div class="w-full my-4 text-center">
    {#if multiple == "multiple"}
      <label for="input-file-drop" class="btn-primary">Sélectionner des photos</label>
    {:else}
      <label for="input-file-drop" class="btn-primary">Sélectionner une photo</label>
    {/if}
  </div>

  <div class="w-full rounded-full">
    <div class="h-1 rounded-full bg-primary" style="width: {uploadCompletion}%; ">
    </div>
  </div>

</label>

{#if errorMessage != ""}
  <div class="w-full my-4 text-sm font-semibold text-center text-red-400">{errorMessage}</div>
{/if}

<input on:change={refreshFileList} multiple="{multiple}" accept="{accept}" class="hidden" type="file" id="input-file-drop">
